import React from 'react'

function Player1() {

    return (
        <div className='container'>
            <div className='row'>

            <h1 className="col-sm-11 col-md-6 col-lg-5 col-xl-6 col-xxl-9 text-center mt-5 winner1">PLAYER 1- <span className='text-dark'>Win</span></h1>

            </div>
        </div>
    )
}

export default Player1